import defaultState from "./state";

const replicarSolicitudReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "REP_SOLICITUD/SET_VALIDACION_USUARIO": {
      return Object.assign({}, state, {
        prestadorPuedeReplicar: action.prestadorPuedeReplicar,
        usuarioPuedeReplicar: action.usuarioPuedeReplicar,
      });
    }

    case "REP_SOLICITUD/MOSTRAR_VALIDACIONES_PARA_REPLICAR": {
      return Object.assign({}, state, {
        modalValidacion: action.value,
      });
    }

    case "REP_SOLICITUD/SET_VALIDACION_EN_CURSO": {
      return Object.assign({}, state, {
        loadingValidacionSolicitudEnCurso: action.value,
      });
    }

    case "REP_SOLICITUD/SET_VALIDACION_CENTROS_ATENCION": {
      return Object.assign({}, state, {
        loadingValidacionCentrosAtencion: action.value,
      });
    }

    case "REP_SOLICITUD/SET_IDS_HOMOLOGOS": {
      return Object.assign({}, state, {
        loadingValidacionIdsHomologos: action.value,
      });
    }

    case "REP_SOLICITUD/SET_IDS_HOMOLOGOS_AUX": {
      return Object.assign({}, state, {
        loadingValidacionIdsHomologosAux: action.value,
      });
    }

    case "REP_SOLICITUD/SET_DETALLE_VALIDACION_CENTROS_ATENCION": {
      if (state.detalleValidacionCentrosAtencion
        .filter((c) => c.secuencia === action.secuencia).length === 0) {
        return Object.assign({}, state, {
          detalleValidacionCentrosAtencion: state.detalleValidacionCentrosAtencion
            .concat([{
              secuencia: action.secuencia,
              valido: action.valido,
              secuenciaHomologo: action.secuenciaHomologo,
            }]),
        });
      }
      return Object.assign({}, state, {
        detalleValidacionCentrosAtencion: state.detalleValidacionCentrosAtencion
          .map((p) => Object.assign({}, p, {
            valido: action.secuencia === p.secuencia ? action.valido : p.valido,
            secuenciaHomologo: action.secuencia === p.secuencia ? action.secuenciaHomologo : p.secuenciaHomologo,
          })),
      });
    }

    case "REP_SOLICITUD/SET_DETALLE_VALIDACION_IDS_HOMOLOGOS": {
      return Object.assign({}, state, {
        idsPrestacionesHomologas: action.idsHomologos,
      });
    }

    case "REP_SOLICITUD/SET_LOADING_DETALLE_SOLICITUD": {
      return Object.assign({}, state, {
        loadingDetalleSolicitud: action.value,
      });
    }

    case "REP_SOLICITUD/DONE_DETALLE_SOLICITUD": {
      return Object.assign({}, state, {
        loadingDetalleSolicitud: (state.loadingDetalleSolicitud - 1),
      });
    }

    case "REP_SOLICITUD/MOSTRAT_SOLICITUD_REPLICADA": {
      return Object.assign({}, state, {
        modalSolicitudReplicada: action.value,
      });
    }

    case "REP_SOLICITUD/GUARDAR_ID_SOLICITUD_REPLICACION": {
      return Object.assign({}, state, {
        idSolicitudReplicada: action.value,
      });
    }

    default:
      return state;
  }
};

export default replicarSolicitudReducer;
